import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import AppBarRegister from '../shared/components/AppBarRegister';
import Typography from '@material-ui/core/Typography';
import MedicalInformationForm from './forms/MedicalInformationForm';
import { formValueSelector } from 'redux-form';
import AccountMedicalInformationCreated from './pages/AccountMedicalInformationCreated';
import { account_update } from '../../redux/actions/accountActions';
import { isMobile } from 'react-device-detect';
import AppBarPortal from '../shared/components/AppBarPortal';

const styles = theme => ({
  root: {
    flexGrow: 1
  }
})

class AccountMedicalInformation extends React.PureComponent {

  state = {
    created: false
  }

  submitMedicalInformation = values => {
    this.props.dispatch(
      account_update({profile: values}, this.props.auth.user_id, this.props.auth.token)
    );
    this.setState({
      created: true
    })
  } 

  componentDidMount() {
    document.body.classList.add("login");
  }

  componentWillUnmount() {
    document.body.classList.remove("login");
  }

  render(){
    return (
      <React.Fragment>
        {!isMobile && <AppBarPortal />}
        {this.state.created && 
          <AccountMedicalInformationCreated {...this.props} />
        }
        {!this.state.created &&
        <React.Fragment>
          <AppBarRegister hideLogo title="Nuevo Voluntario" />
          <Typography variant="caption" align="center">Información Personal</Typography>
          <div style={{padding: 15, paddingTop: 0}}>
            <MedicalInformationForm onSubmit={this.submitMedicalInformation} {...this.props}  />
          </div>
        </React.Fragment>
        }
      </React.Fragment>
    )
  }
}

const selector = formValueSelector('volunteerMedicalInformation');

const mapStateToProps = (state) => {
  return {
      auth: state.auth,
      common: state.common,
      form_disease_type_value: selector(state, 'disease_type'),
      form_other_treatment_value: selector(state, 'other_treatment'), 
      form_had_surgery_value: selector(state, 'had_surgery'), 
      form_skin_affections_value: selector(state, 'skin_affections'), 
      form_has_allergies_value: selector(state, 'has_allergies'),
      form_family_has_allergies_value: selector(state, 'family_has_allergies'),
      form_food_allergies_value: selector(state, 'food_allergies'),
      form_drug_allergies_value: selector(state, 'drug_allergies'),
      form_cosmetic_product_allergies_value: selector(state, 'cosmetic_product_allergies'),
      form_height_value: selector(state, 'height'),
      form_weight_value: selector(state, 'weight'),
      form_smoking_value: selector(state, 'smoking'),
      form_tattoos_value: selector(state, 'has_tattoos'),
      form_health_and_care_products_value: selector(state, 'health_and_care_products'),
      form_hair_removal_products_value: selector(state, 'hair_removal_products'),
      form_had_laser_hair_removal_value: selector(state, 'had_laser_hair_removal'),
  };
};

export default withRouter(
  connect(mapStateToProps)(
    withStyles(styles, {withTheme: true})(AccountMedicalInformation)
  )
)



// WEBPACK FOOTER //
// ./src/modules/account/AccountMedicalInformation.js